// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 42177, offsets 510330:557646. Structure and names inferred from code, not screenshots.
import { loadArchivedChunk, loadArchivedModule } from "../vendor/runtime.js";
let archivedDocuments = [
  {
    path: "zh-CN/quick-start/summary/welcome",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(3401),
      ]).then(() => loadArchivedModule(51456)),
    key: "zh-CN-欢迎使用",
    modifiedTime: ["1790130402", "1790130414"],
  },
  {
    path: "en-US/quick-start/summary/welcome",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(4659),
      ]).then(() => loadArchivedModule(31102)),
    key: "en-US-欢迎使用",
    modifiedTime: ["1790130402", "1790130414"],
  },
  {
    path: "zh-CN/quick-start/summary/first-api-call",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2464),
      ]).then(() => loadArchivedModule(19827)),
    key: "zh-CN-首次调用API",
    modifiedTime: ["1790010243", "1790010573"],
  },
  {
    path: "en-US/quick-start/summary/first-api-call",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4079),
      ]).then(() => loadArchivedModule(93218)),
    key: "en-US-首次调用API",
    modifiedTime: ["1790010243", "1790010573"],
  },
  {
    path: "zh-CN/quick-start/summary/model",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8531),
      ]).then(() => loadArchivedModule(45662)),
    key: "zh-CN-DocN1779363396197jfv4ufh",
    modifiedTime: ["1790076406", "1790076410"],
  },
  {
    path: "en-US/quick-start/summary/model",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4273),
      ]).then(() => loadArchivedModule(54376)),
    key: "en-US-DocN1779363396197jfv4ufh",
    modifiedTime: ["1790076406", "1790076410"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/text-generation/tool-calling/web-search",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5235),
      ]).then(() => loadArchivedModule(48622)),
    key: "zh-CN-联网搜索",
    modifiedTime: ["1790008360", "1790008374"],
  },
  {
    path: "en-US/quick-start/usage-guide/text-generation/tool-calling/web-search",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5299),
      ]).then(() => loadArchivedModule(77534)),
    key: "en-US-联网搜索",
    modifiedTime: ["1790008360", "1790008374"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/text-generation/deep-thinking",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6422),
      ]).then(() => loadArchivedModule(14485)),
    key: "zh-CN-DocN1778593283100osa5iza",
    modifiedTime: ["1790008917", "1790008926"],
  },
  {
    path: "en-US/quick-start/usage-guide/text-generation/deep-thinking",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5505),
      ]).then(() => loadArchivedModule(35640)),
    key: "en-US-DocN1778593283100osa5iza",
    modifiedTime: ["1790008917", "1790008926"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/text-generation/structured-output",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2060),
      ]).then(() => loadArchivedModule(30551)),
    key: "zh-CN-DocN17822182151579ah0etq",
    modifiedTime: ["1790008489", "1790011195"],
  },
  {
    path: "en-US/quick-start/usage-guide/text-generation/structured-output",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7876),
      ]).then(() => loadArchivedModule(23039)),
    key: "en-US-DocN17822182151579ah0etq",
    modifiedTime: ["1790008489", "1790011195"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/text-generation/batch-api",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(687),
      ]).then(() => loadArchivedModule(15778)),
    key: "zh-CN-DocN1789834486753ozhvdtx",
    modifiedTime: ["1790153169", "1790153158"],
  },
  {
    path: "en-US/quick-start/usage-guide/text-generation/batch-api",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5991),
      ]).then(() => loadArchivedModule(69530)),
    key: "en-US-DocN1789834486753ozhvdtx",
    modifiedTime: ["1790153169", "1790153158"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/multimodal-understanding/image-understanding",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9078),
      ]).then(() => loadArchivedModule(93237)),
    key: "zh-CN-图片理解",
    modifiedTime: ["1790007901", "1790007929"],
  },
  {
    path: "en-US/quick-start/usage-guide/multimodal-understanding/image-understanding",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1063),
      ]).then(() => loadArchivedModule(13850)),
    key: "en-US-图片理解",
    modifiedTime: ["1790007901", "1790007929"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/multimodal-understanding/audio-understanding",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(274),
      ]).then(() => loadArchivedModule(11897)),
    key: "zh-CN-音频理解",
    modifiedTime: ["1790007971", "1790007985"],
  },
  {
    path: "en-US/quick-start/usage-guide/multimodal-understanding/audio-understanding",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3048),
      ]).then(() => loadArchivedModule(2763)),
    key: "en-US-音频理解",
    modifiedTime: ["1790007971", "1790007985"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/multimodal-understanding/video-understanding",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1078),
      ]).then(() => loadArchivedModule(2725)),
    key: "zh-CN-视频理解",
    modifiedTime: ["1790008285", "1790008312"],
  },
  {
    path: "en-US/quick-start/usage-guide/multimodal-understanding/video-understanding",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(178),
      ]).then(() => loadArchivedModule(44873)),
    key: "en-US-视频理解",
    modifiedTime: ["1790008285", "1790008312"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/audio/Speech-Recognition",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4229),
      ]).then(() => loadArchivedModule(74388)),
    key: "zh-CN-DocN1780315303299uy88nb2",
    modifiedTime: ["1784166604101", "1784172444101"],
  },
  {
    path: "en-US/quick-start/usage-guide/audio/Speech-Recognition",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8956),
      ]).then(() => loadArchivedModule(96151)),
    key: "en-US-DocN1780315303299uy88nb2",
    modifiedTime: ["1784166604101", "1784172444101"],
  },
  {
    path: "zh-CN/quick-start/usage-guide/audio/speech-synthesis-v2.5",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7936),
      ]).then(() => loadArchivedModule(42275)),
    key: "zh-CN-DocN177660798139053zprl9",
    modifiedTime: ["1784105669101", "1784172492101"],
  },
  {
    path: "en-US/quick-start/usage-guide/audio/speech-synthesis-v2.5",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4833),
      ]).then(() => loadArchivedModule(87592)),
    key: "en-US-DocN177660798139053zprl9",
    modifiedTime: ["1784105669101", "1784172492101"],
  },
  {
    path: "zh-CN/quick-start/promotions/refer",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5739),
      ]).then(() => loadArchivedModule(27206)),
    key: "zh-CN-DocN1777431776967fa654rw",
    modifiedTime: ["1786625688", "1786625804"],
  },
  {
    path: "en-US/quick-start/promotions/refer",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4115),
      ]).then(() => loadArchivedModule(79438)),
    key: "en-US-DocN1777431776967fa654rw",
    modifiedTime: ["1786625688", "1786625804"],
  },
  {
    path: "zh-CN/quick-start/faq/account",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1444),
      ]).then(() => loadArchivedModule(61631)),
    key: "zh-CN-DocN1781194014029s7vwo4c",
    modifiedTime: ["1783062695101", "1781242325101"],
  },
  {
    path: "en-US/quick-start/faq/account",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(305),
      ]).then(() => loadArchivedModule(99528)),
    key: "en-US-DocN1781194014029s7vwo4c",
    modifiedTime: ["1783062695101", "1781242325101"],
  },
  {
    path: "zh-CN/quick-start/faq/payment",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1597),
      ]).then(() => loadArchivedModule(33356)),
    key: "zh-CN-DocN1781194112632ijfv5ds",
    modifiedTime: ["1789440079", "1789440063"],
  },
  {
    path: "en-US/quick-start/faq/payment",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1056),
      ]).then(() => loadArchivedModule(68195)),
    key: "en-US-DocN1781194112632ijfv5ds",
    modifiedTime: ["1789440079", "1789440063"],
  },
  {
    path: "zh-CN/quick-start/faq/api-integration",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4583),
      ]).then(() => loadArchivedModule(42410)),
    key: "zh-CN-DocN1781194188134qbwxpnv",
    modifiedTime: ["1789914609", "1789914664"],
  },
  {
    path: "en-US/quick-start/faq/api-integration",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6301),
      ]).then(() => loadArchivedModule(68316)),
    key: "en-US-DocN1781194188134qbwxpnv",
    modifiedTime: ["1789914609", "1789914664"],
  },
  {
    path: "zh-CN/quick-start/faq/token-plan/Plans&Pricing",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1159),
      ]).then(() => loadArchivedModule(48858)),
    key: "zh-CN-DocN1790079887970yctjl2y",
    modifiedTime: ["1790077656", "1790077700"],
  },
  {
    path: "en-US/quick-start/faq/token-plan/Plans&Pricing",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6871),
      ]).then(() => loadArchivedModule(10170)),
    key: "en-US-DocN1790079887970yctjl2y",
    modifiedTime: ["1790077656", "1790077700"],
  },
  {
    path: "zh-CN/quick-start/faq/token-plan/Validity&Expiry",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2100),
      ]).then(() => loadArchivedModule(97343)),
    key: "zh-CN-DocN1790079887376s4qgbbn",
    modifiedTime: ["1790077740", "1790077755"],
  },
  {
    path: "en-US/quick-start/faq/token-plan/Validity&Expiry",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2955),
      ]).then(() => loadArchivedModule(52710)),
    key: "en-US-DocN1790079887376s4qgbbn",
    modifiedTime: ["1790077740", "1790077755"],
  },
  {
    path: "zh-CN/quick-start/faq/token-plan/Usage&Quota",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3316),
      ]).then(() => loadArchivedModule(4863)),
    key: "zh-CN-DocN17900798865598yyudav",
    modifiedTime: ["1790077793", "1790077812"],
  },
  {
    path: "en-US/quick-start/faq/token-plan/Usage&Quota",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3778),
      ]).then(() => loadArchivedModule(84649)),
    key: "en-US-DocN17900798865598yyudav",
    modifiedTime: ["1790077793", "1790077812"],
  },
  {
    path: "zh-CN/quick-start/faq/token-plan/Team-Benefits",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4909),
      ]).then(() => loadArchivedModule(28252)),
    key: "zh-CN-DocN1790079884540wz0vtg2",
    modifiedTime: ["1790077854", "1790077876"],
  },
  {
    path: "en-US/quick-start/faq/token-plan/Team-Benefits",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(383),
      ]).then(() => loadArchivedModule(34482)),
    key: "en-US-DocN1790079884540wz0vtg2",
    modifiedTime: ["1790077854", "1790077876"],
  },
  {
    path: "zh-CN/quick-start/faq/token-plan/desktop-guide",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2694),
      ]).then(() => loadArchivedModule(93925)),
    key: "zh-CN-DocN1790078591679ljvqsow",
    modifiedTime: ["1790144807", "1790144818"],
  },
  {
    path: "en-US/quick-start/faq/token-plan/desktop-guide",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3939),
      ]).then(() => loadArchivedModule(72542)),
    key: "en-US-DocN1790078591679ljvqsow",
    modifiedTime: ["1790144807", "1790144818"],
  },
  {
    path: "zh-CN/quick-start/faq/promotions",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7796),
      ]).then(() => loadArchivedModule(24559)),
    key: "zh-CN-DocN1781194343713518kic4",
    modifiedTime: ["1786628213", "1786626260"],
  },
  {
    path: "en-US/quick-start/faq/promotions",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6879),
      ]).then(() => loadArchivedModule(40306)),
    key: "en-US-DocN1781194343713518kic4",
    modifiedTime: ["1786628213", "1786626260"],
  },
  {
    path: "zh-CN/quick-start/faq/others",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5736),
      ]).then(() => loadArchivedModule(33691)),
    key: "zh-CN-DocN17811943745783rwbhjh",
    modifiedTime: ["1781242458101", "1781242465101"],
  },
  {
    path: "en-US/quick-start/faq/others",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5065),
      ]).then(() => loadArchivedModule(34064)),
    key: "en-US-DocN17811943745783rwbhjh",
    modifiedTime: ["1781242458101", "1781242465101"],
  },
  {
    path: "quick-start/terms/user-agreement",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1995),
      ]).then(() => loadArchivedModule(44262)),
    key: "agreement-DocN1786673539910kitzo5f",
    modifiedTime: ["1783407374101", "1785990636"],
  },
  {
    path: "zh-CN/api/guidance/rate-limit",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8038),
      ]).then(() => loadArchivedModule(10085)),
    key: "zh-CN-DocN1781193803862f57dfx6",
    modifiedTime: ["1789963040", "1789963060"],
  },
  {
    path: "en-US/api/guidance/rate-limit",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7499),
      ]).then(() => loadArchivedModule(3750)),
    key: "en-US-DocN1781193803862f57dfx6",
    modifiedTime: ["1789963040", "1789963060"],
  },
  {
    path: "zh-CN/api/guidance/model-hyperparameters",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7430),
      ]).then(() => loadArchivedModule(77525)),
    key: "zh-CN-模型超参",
    modifiedTime: ["1789914710", "1789914751"],
  },
  {
    path: "en-US/api/guidance/model-hyperparameters",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2495),
      ]).then(() => loadArchivedModule(92322)),
    key: "en-US-模型超参",
    modifiedTime: ["1789914710", "1789914751"],
  },
  {
    path: "zh-CN/api/guidance/error-codes",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3060),
      ]).then(() => loadArchivedModule(81487)),
    key: "zh-CN-错误码",
    modifiedTime: ["1784105798101", "1784105805101"],
  },
  {
    path: "en-US/api/guidance/error-codes",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2091),
      ]).then(() => loadArchivedModule(13926)),
    key: "en-US-错误码",
    modifiedTime: ["1784105798101", "1784105805101"],
  },
  {
    path: "zh-CN/api/chat/openai-api",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(7937),
      ]).then(() => loadArchivedModule(96712)),
    key: "zh-CN-OpenAIAPI",
    modifiedTime: ["1789908728", "1790011983", "1790009292524"],
  },
  {
    path: "en-US/api/chat/openai-api",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(3732),
      ]).then(() => loadArchivedModule(50559)),
    key: "en-US-OpenAIAPI",
    modifiedTime: ["1789908728", "1790011983", "1790009292524"],
  },
  {
    path: "zh-CN/api/chat/responses",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(5581),
      ]).then(() => loadArchivedModule(72748)),
    key: "zh-CN-DocN1782213328622dg9dfp1",
    modifiedTime: ["1789909550", "1789910098", "1790009541108"],
  },
  {
    path: "en-US/api/chat/responses",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(3540),
      ]).then(() => loadArchivedModule(82442)),
    key: "en-US-DocN1782213328622dg9dfp1",
    modifiedTime: ["1789909550", "1789910098", "1790009541108"],
  },
  {
    path: "zh-CN/api/chat/anthropic-api",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(5049),
      ]).then(() => loadArchivedModule(31856)),
    key: "zh-CN-AnthropicAPI",
    modifiedTime: ["1790012484", "1789908356", "1790009451552"],
  },
  {
    path: "en-US/api/chat/anthropic-api",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(5103),
      ]).then(() => loadArchivedModule(13138)),
    key: "en-US-AnthropicAPI",
    modifiedTime: ["1790012484", "1789908356", "1790009451552"],
  },
  {
    path: "zh-CN/api/audio/Speech-Recognition",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(4196),
      ]).then(() => loadArchivedModule(36383)),
    key: "zh-CN-DocN1780315041317lfr16fn",
    modifiedTime: ["1784290041101", "1784290020101", "1780398493390"],
  },
  {
    path: "en-US/api/audio/Speech-Recognition",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(1889),
      ]).then(() => loadArchivedModule(36536)),
    key: "en-US-DocN1780315041317lfr16fn",
    modifiedTime: ["1784290041101", "1784290020101", "1780398493390"],
  },
  {
    path: "zh-CN/api/audio/tts",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(3409),
      ]).then(() => loadArchivedModule(62040)),
    key: "zh-CN-DocN1784276871820bmjkrap",
    modifiedTime: ["1784290048101", "1784290027101", "1784285428696"],
  },
  {
    path: "en-US/api/audio/tts",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(2064),
      ]).then(() => loadArchivedModule(14195)),
    key: "en-US-DocN1784276871820bmjkrap",
    modifiedTime: ["1784290048101", "1784290027101", "1784285428696"],
  },
  {
    path: "zh-CN/api/model/list-models",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(306),
      ]).then(() => loadArchivedModule(53017)),
    key: "zh-CN-DocN1784277191339hovmpz5",
    modifiedTime: ["1784290062101", "1784290078101", "1790009604027"],
  },
  {
    path: "en-US/api/model/list-models",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(4022),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3193),
        loadArchivedChunk(9386),
      ]).then(() => loadArchivedModule(92465)),
    key: "en-US-DocN1784277191339hovmpz5",
    modifiedTime: ["1784290062101", "1784290078101", "1790009604027"],
  },
  {
    path: "zh-CN/price/pay-as-you-go",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5716),
      ]).then(() => loadArchivedModule(23596)),
    key: "zh-CN-DocN1779362602960w0aorte",
    modifiedTime: ["1790076340", "1790076423"],
  },
  {
    path: "en-US/price/pay-as-you-go",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2164),
      ]).then(() => loadArchivedModule(28383)),
    key: "en-US-DocN1779362602960w0aorte",
    modifiedTime: ["1790076340", "1790076423"],
  },
  {
    path: "zh-CN/price/token-plan",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(824),
      ]).then(() => loadArchivedModule(71883)),
    key: "zh-CN-DocN17811939662011r0fqy6",
    modifiedTime: ["1789984219", "1789984226"],
  },
  {
    path: "en-US/price/token-plan",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5559),
      ]).then(() => loadArchivedModule(15098)),
    key: "en-US-DocN17811939662011r0fqy6",
    modifiedTime: ["1789984219", "1789984226"],
  },
  {
    path: "zh-CN/tokenplan/Token Plan/subscription",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8738),
      ]).then(() => loadArchivedModule(75497)),
    key: "zh-CN-DocN17750482164475jo5paj",
    modifiedTime: ["1790083883", "1790083876"],
  },
  {
    path: "en-US/tokenplan/Token Plan/subscription",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4405),
      ]).then(() => loadArchivedModule(37620)),
    key: "en-US-DocN17750482164475jo5paj",
    modifiedTime: ["1790083883", "1790083876"],
  },
  {
    path: "zh-CN/tokenplan/Token Plan/team",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(573),
      ]).then(() => loadArchivedModule(19964)),
    key: "zh-CN-DocN1789834577920i6n17sp",
    modifiedTime: ["1790080945", "1790080956"],
  },
  {
    path: "en-US/tokenplan/Token Plan/team",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4643),
      ]).then(() => loadArchivedModule(59262)),
    key: "en-US-DocN1789834577920i6n17sp",
    modifiedTime: ["1790080945", "1790080956"],
  },
  {
    path: "zh-CN/tokenplan/Token Plan/quick-access",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2039),
      ]).then(() => loadArchivedModule(41434)),
    key: "zh-CN-DocN177504827814890amj7g",
    modifiedTime: ["1790000701", "1790000741"],
  },
  {
    path: "en-US/tokenplan/Token Plan/quick-access",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8963),
      ]).then(() => loadArchivedModule(61486)),
    key: "en-US-DocN177504827814890amj7g",
    modifiedTime: ["1790000701", "1790000741"],
  },
  {
    path: "zh-CN/tokenplan/integration/tools-overview",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2531),
      ]).then(() => loadArchivedModule(11694)),
    key: "zh-CN-DocN1775045210877siggce7",
    modifiedTime: ["1789628161", "1790014044"],
  },
  {
    path: "en-US/tokenplan/integration/tools-overview",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4267),
      ]).then(() => loadArchivedModule(54598)),
    key: "en-US-DocN1775045210877siggce7",
    modifiedTime: ["1789628161", "1790014044"],
  },
  {
    path: "zh-CN/tokenplan/integration/mimo-desktop",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4378),
      ]).then(() => loadArchivedModule(82465)),
    key: "zh-CN-DocN17895294461732yk0fy8",
    modifiedTime: ["1790025404", "1790025411"],
  },
  {
    path: "en-US/tokenplan/integration/mimo-desktop",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9598),
      ]).then(() => loadArchivedModule(49629)),
    key: "en-US-DocN17895294461732yk0fy8",
    modifiedTime: ["1790025404", "1790025411"],
  },
  {
    path: "zh-CN/tokenplan/integration/mimo-code",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3834),
      ]).then(() => loadArchivedModule(71889)),
    key: "zh-CN-DocN1781193884498p0umhfi",
    modifiedTime: ["1785842945101", "1789960378"],
  },
  {
    path: "en-US/tokenplan/integration/mimo-code",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4269),
      ]).then(() => loadArchivedModule(21404)),
    key: "en-US-DocN1781193884498p0umhfi",
    modifiedTime: ["1785842945101", "1789960378"],
  },
  {
    path: "zh-CN/tokenplan/integration/opencode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2782),
      ]).then(() => loadArchivedModule(76061)),
    key: "zh-CN-DocN1775048360011j296mr3",
    modifiedTime: ["1790014648", "1790014717"],
  },
  {
    path: "en-US/tokenplan/integration/opencode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2724),
      ]).then(() => loadArchivedModule(41551)),
    key: "en-US-DocN1775048360011j296mr3",
    modifiedTime: ["1790014648", "1790014717"],
  },
  {
    path: "zh-CN/tokenplan/integration/claudecode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4036),
      ]).then(() => loadArchivedModule(71679)),
    key: "zh-CN-DocN1775048427262umnmo58",
    modifiedTime: ["1789628441", "1790014246"],
  },
  {
    path: "en-US/tokenplan/integration/claudecode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9517),
      ]).then(() => loadArchivedModule(14940)),
    key: "en-US-DocN1775048427262umnmo58",
    modifiedTime: ["1789628441", "1790014246"],
  },
  {
    path: "zh-CN/tokenplan/integration/codex-configuration",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5395),
      ]).then(() => loadArchivedModule(10878)),
    key: "zh-CN-DocN17822184184849s2ztsh",
    modifiedTime: ["1790009997", "1790010088"],
  },
  {
    path: "en-US/tokenplan/integration/codex-configuration",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4855),
      ]).then(() => loadArchivedModule(15930)),
    key: "en-US-DocN17822184184849s2ztsh",
    modifiedTime: ["1790009997", "1790010088"],
  },
  {
    path: "zh-CN/tokenplan/integration/openclaw",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5799),
      ]).then(() => loadArchivedModule(94490)),
    key: "zh-CN-DocN17750485751773obloc2",
    modifiedTime: ["1790014851", "1790014226"],
  },
  {
    path: "en-US/tokenplan/integration/openclaw",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9465),
      ]).then(() => loadArchivedModule(80704)),
    key: "en-US-DocN17750485751773obloc2",
    modifiedTime: ["1790014851", "1790014226"],
  },
  {
    path: "zh-CN/tokenplan/integration/hermes-agent",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6742),
      ]).then(() => loadArchivedModule(2165)),
    key: "zh-CN-DocN1777347006361p8hs75u",
    modifiedTime: ["1789628699", "1790014477"],
  },
  {
    path: "en-US/tokenplan/integration/hermes-agent",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6318),
      ]).then(() => loadArchivedModule(81165)),
    key: "en-US-DocN1777347006361p8hs75u",
    modifiedTime: ["1789628699", "1790014477"],
  },
  {
    path: "zh-CN/tokenplan/integration/kilocode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(554),
      ]).then(() => loadArchivedModule(865)),
    key: "zh-CN-DocN1775048681541bug5rvb",
    modifiedTime: ["1789628740", "1790014264"],
  },
  {
    path: "en-US/tokenplan/integration/kilocode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2236),
      ]).then(() => loadArchivedModule(48183)),
    key: "en-US-DocN1775048681541bug5rvb",
    modifiedTime: ["1789628740", "1790014264"],
  },
  {
    path: "zh-CN/tokenplan/integration/chatbox",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(96),
      ]).then(() => loadArchivedModule(3475)),
    key: "zh-CN-DocN1789375696536m8opzhq",
    modifiedTime: ["1789628777", "1790014429"],
  },
  {
    path: "en-US/tokenplan/integration/chatbox",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6285),
      ]).then(() => loadArchivedModule(13788)),
    key: "en-US-DocN1789375696536m8opzhq",
    modifiedTime: ["1789628777", "1790014429"],
  },
  {
    path: "zh-CN/tokenplan/integration/cherrystudio",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1972),
      ]).then(() => loadArchivedModule(65631)),
    key: "zh-CN-DocN1775052953767s596ukv",
    modifiedTime: ["1789628817", "1790014413"],
  },
  {
    path: "en-US/tokenplan/integration/cherrystudio",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1345),
      ]).then(() => loadArchivedModule(77624)),
    key: "en-US-DocN1775052953767s596ukv",
    modifiedTime: ["1789628817", "1790014413"],
  },
  {
    path: "zh-CN/tokenplan/integration/qwencode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2753),
      ]).then(() => loadArchivedModule(82520)),
    key: "zh-CN-DocN1775052954597l3yriqm",
    modifiedTime: ["1789628857", "1790015261"],
  },
  {
    path: "en-US/tokenplan/integration/qwencode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(685),
      ]).then(() => loadArchivedModule(48156)),
    key: "en-US-DocN1775052954597l3yriqm",
    modifiedTime: ["1789628857", "1790015261"],
  },
  {
    path: "zh-CN/tokenplan/integration/codebuddy",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6315),
      ]).then(() => loadArchivedModule(36150)),
    key: "zh-CN-DocN1778136035914vqw1yty",
    modifiedTime: ["1789628889", "1790014503"],
  },
  {
    path: "en-US/tokenplan/integration/codebuddy",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8025),
      ]).then(() => loadArchivedModule(5520)),
    key: "en-US-DocN1778136035914vqw1yty",
    modifiedTime: ["1789628889", "1790014503"],
  },
  {
    path: "zh-CN/tokenplan/integration/cline",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2426),
      ]).then(() => loadArchivedModule(1681)),
    key: "zh-CN-DocN1775048767767zoe1a67",
    modifiedTime: ["1789975519", "1790014281"],
  },
  {
    path: "en-US/tokenplan/integration/cline",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3727),
      ]).then(() => loadArchivedModule(99010)),
    key: "en-US-DocN1775048767767zoe1a67",
    modifiedTime: ["1789975519", "1790014281"],
  },
  {
    path: "zh-CN/news/latest/v2-6",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9477),
      ]).then(() => loadArchivedModule(23300)),
    key: "zh-CN-DocN178983510328300zqtiy",
    modifiedTime: ["1790048117", "1790048056"],
  },
  {
    path: "en-US/news/latest/v2-6",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3290),
      ]).then(() => loadArchivedModule(19809)),
    key: "en-US-DocN178983510328300zqtiy",
    modifiedTime: ["1790048117", "1790048056"],
  },
  {
    path: "zh-CN/news/latest/mimo-desktop",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9596),
      ]).then(() => loadArchivedModule(599)),
    key: "zh-CN-DocN1788148405512lb92jq6",
    modifiedTime: ["1788848078", "1788848309"],
  },
  {
    path: "en-US/news/latest/mimo-desktop",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4746),
      ]).then(() => loadArchivedModule(91473)),
    key: "en-US-DocN1788148405512lb92jq6",
    modifiedTime: ["1788848078", "1788848309"],
  },
  {
    path: "zh-CN/news/latest/beta-extended",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6582),
      ]).then(() => loadArchivedModule(74821)),
    key: "zh-CN-DocN1782208889073v35sizz",
    modifiedTime: ["1788337767", "1788836195"],
  },
  {
    path: "en-US/news/latest/beta-extended",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5236),
      ]).then(() => loadArchivedModule(39103)),
    key: "en-US-DocN1782208889073v35sizz",
    modifiedTime: ["1788337767", "1788836195"],
  },
  {
    path: "zh-CN/news/latest/mimoclaw",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1742),
      ]).then(() => loadArchivedModule(13501)),
    key: "zh-CN-DocN1781540291772yvwkw95",
    modifiedTime: ["1787205036", "1787123883"],
  },
  {
    path: "en-US/news/latest/mimoclaw",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8184),
      ]).then(() => loadArchivedModule(67707)),
    key: "en-US-DocN1781540291772yvwkw95",
    modifiedTime: ["1787205036", "1787123883"],
  },
  {
    path: "zh-CN/news/latest/mimocode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2788),
      ]).then(() => loadArchivedModule(49727)),
    key: "zh-CN-DocN1781506823785immr2mn",
    modifiedTime: ["1781513520101", "1781513558101"],
  },
  {
    path: "en-US/news/latest/mimocode",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2816),
      ]).then(() => loadArchivedModule(49379)),
    key: "en-US-DocN1781506823785immr2mn",
    modifiedTime: ["1781513520101", "1781513558101"],
  },
  {
    path: "zh-CN/news/latest/1000tps",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1067),
      ]).then(() => loadArchivedModule(89606)),
    key: "zh-CN-DocN178150672877474axwja",
    modifiedTime: ["1788337823", "1788836210"],
  },
  {
    path: "en-US/news/latest/1000tps",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2),
      ]).then(() => loadArchivedModule(24745)),
    key: "en-US-DocN178150672877474axwja",
    modifiedTime: ["1788337823", "1788836210"],
  },
  {
    path: "zh-CN/news/latest/updqate",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5106),
      ]).then(() => loadArchivedModule(55737)),
    key: "zh-CN-DocN1781506652696vzbgw08",
    modifiedTime: ["1782699385101", "1782699458101"],
  },
  {
    path: "en-US/news/latest/updqate",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8759),
      ]).then(() => loadArchivedModule(72650)),
    key: "en-US-DocN1781506652696vzbgw08",
    modifiedTime: ["1782699385101", "1782699458101"],
  },
  {
    path: "zh-CN/news/latest/v2.5-orbit",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7213),
      ]).then(() => loadArchivedModule(87532)),
    key: "zh-CN-DocN1780017152291q587hgl",
    modifiedTime: ["1782699658101", "1782699666101"],
  },
  {
    path: "en-US/news/latest/v2.5-orbit",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8816),
      ]).then(() => loadArchivedModule(12883)),
    key: "en-US-DocN1780017152291q587hgl",
    modifiedTime: ["1782699658101", "1782699666101"],
  },
  {
    path: "zh-CN/news/latest/v2.5-price-update",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1589),
      ]).then(() => loadArchivedModule(55812)),
    key: "zh-CN-DocN1779811946298ov7fz0l",
    modifiedTime: ["1782701603101", "1782699857101"],
  },
  {
    path: "en-US/news/latest/v2.5-price-update",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1196),
      ]).then(() => loadArchivedModule(75975)),
    key: "en-US-DocN1779811946298ov7fz0l",
    modifiedTime: ["1782701603101", "1782699857101"],
  },
  {
    path: "zh-CN/news/latest/v2.5-open-sourced",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7938),
      ]).then(() => loadArchivedModule(12009)),
    key: "zh-CN-DocN1777308794609qami4cf",
    modifiedTime: ["1782700135101", "1782700163101"],
  },
  {
    path: "en-US/news/latest/v2.5-open-sourced",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2251),
      ]).then(() => loadArchivedModule(486)),
    key: "en-US-DocN1777308794609qami4cf",
    modifiedTime: ["1782700135101", "1782700163101"],
  },
  {
    path: "zh-CN/news/latest/v2.5-tts-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(928),
      ]).then(() => loadArchivedModule(7235)),
    key: "zh-CN-DocN17769641222670m02x7f",
    modifiedTime: ["1779951150101", "1779951163101"],
  },
  {
    path: "en-US/news/latest/v2.5-tts-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3109),
      ]).then(() => loadArchivedModule(79188)),
    key: "en-US-DocN17769641222670m02x7f",
    modifiedTime: ["1779951150101", "1779951163101"],
  },
  {
    path: "zh-CN/news/latest/v2.5-news",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2169),
      ]).then(() => loadArchivedModule(78592)),
    key: "zh-CN-DocN1776876244468dwer7km",
    modifiedTime: ["1782700459101", "1782700512101"],
  },
  {
    path: "en-US/news/latest/v2.5-news",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8586),
      ]).then(() => loadArchivedModule(47233)),
    key: "en-US-DocN1776876244468dwer7km",
    modifiedTime: ["1782700459101", "1782700512101"],
  },
  {
    path: "zh-CN/news/latest/hermes-free",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3782),
      ]).then(() => loadArchivedModule(14853)),
    key: "zh-CN-DocN1775824365185xsit1kc",
    modifiedTime: ["1782700601101", "1782700613101"],
  },
  {
    path: "en-US/news/latest/hermes-free",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3975),
      ]).then(() => loadArchivedModule(65226)),
    key: "en-US-DocN1775824365185xsit1kc",
    modifiedTime: ["1782700601101", "1782700613101"],
  },
  {
    path: "zh-CN/news/latest/token-plan-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9130),
      ]).then(() => loadArchivedModule(22145)),
    key: "zh-CN-DocN1775123228510xguwj8b",
    modifiedTime: ["1782700741101", "1782700753101"],
  },
  {
    path: "en-US/news/latest/token-plan-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6427),
      ]).then(() => loadArchivedModule(70070)),
    key: "en-US-DocN1775123228510xguwj8b",
    modifiedTime: ["1782700741101", "1782700753101"],
  },
  {
    path: "zh-CN/news/latest/free-trial-extension",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7610),
      ]).then(() => loadArchivedModule(84033)),
    key: "zh-CN-DocN1774705656712nsq4knm",
    modifiedTime: ["1782700834101", "1782700839101"],
  },
  {
    path: "en-US/news/latest/free-trial-extension",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5076),
      ]).then(() => loadArchivedModule(71151)),
    key: "en-US-DocN1774705656712nsq4knm",
    modifiedTime: ["1782700834101", "1782700839101"],
  },
  {
    path: "zh-CN/news/previous-news/first-week-free",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9718),
      ]).then(() => loadArchivedModule(10885)),
    key: "zh-CN-DocDb9eb0846bf64d50",
    modifiedTime: ["1782700938101", "1782700977101"],
  },
  {
    path: "en-US/news/previous-news/first-week-free",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7911),
      ]).then(() => loadArchivedModule(27770)),
    key: "en-US-DocDb9eb0846bf64d50",
    modifiedTime: ["1782700938101", "1782700977101"],
  },
  {
    path: "zh-CN/news/previous-news/v2-pro-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3636),
      ]).then(() => loadArchivedModule(66959)),
    key: "zh-CN-XiaomiMiMoV2Pro发布面向Agent时代的旗舰基座",
    modifiedTime: ["1782701045101", "1782701059101"],
  },
  {
    path: "en-US/news/previous-news/v2-pro-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4053),
      ]).then(() => loadArchivedModule(70708)),
    key: "en-US-XiaomiMiMoV2Pro发布面向Agent时代的旗舰基座",
    modifiedTime: ["1782701045101", "1782701059101"],
  },
  {
    path: "zh-CN/news/previous-news/v2-omni-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(9408),
      ]).then(() => loadArchivedModule(18179)),
    key: "zh-CN-XiaomiMiMoV2Omni发布看得清听得懂能动手的全模态Agent基座",
    modifiedTime: ["1782701088101", "1782701097101"],
  },
  {
    path: "en-US/news/previous-news/v2-omni-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4809),
      ]).then(() => loadArchivedModule(89696)),
    key: "en-US-XiaomiMiMoV2Omni发布看得清听得懂能动手的全模态Agent基座",
    modifiedTime: ["1782701088101", "1782701097101"],
  },
  {
    path: "zh-CN/news/previous-news/v2-tts-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7097),
      ]).then(() => loadArchivedModule(86080)),
    key: "zh-CN-XiaomiMiMoV2TTS发布能说会唱的语音合成大模型",
    modifiedTime: ["1779950186101", "1779950197101"],
  },
  {
    path: "en-US/news/previous-news/v2-tts-release",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6941),
      ]).then(() => loadArchivedModule(90188)),
    key: "en-US-XiaomiMiMoV2TTS发布能说会唱的语音合成大模型",
    modifiedTime: ["1779950186101", "1779950197101"],
  },
  {
    path: "zh-CN/news/previous-news/news20260303",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5007),
      ]).then(() => loadArchivedModule(11186)),
    key: "zh-CN-MiMoV2Flash更新日志20260303",
    modifiedTime: ["1779950241101", "1779950250101"],
  },
  {
    path: "en-US/news/previous-news/news20260303",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6421),
      ]).then(() => loadArchivedModule(8324)),
    key: "en-US-MiMoV2Flash更新日志20260303",
    modifiedTime: ["1779950241101", "1779950250101"],
  },
  {
    path: "zh-CN/news/previous-news/news20260212",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3124),
      ]).then(() => loadArchivedModule(57919)),
    key: "zh-CN-MiMoV2Flash更新日志20260204",
    modifiedTime: ["1779950314101", "1779950318101"],
  },
  {
    path: "en-US/news/previous-news/news20260212",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1027),
      ]).then(() => loadArchivedModule(41102)),
    key: "en-US-MiMoV2Flash更新日志20260204",
    modifiedTime: ["1779950314101", "1779950318101"],
  },
  {
    path: "zh-CN/news/previous-news/billing",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6595),
      ]).then(() => loadArchivedModule(11342)),
    key: "zh-CN-XiaomiMiMoAPI开放平台计费即将启动",
    modifiedTime: ["1779936915101", "1779936970101"],
  },
  {
    path: "en-US/news/previous-news/billing",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7740),
      ]).then(() => loadArchivedModule(92471)),
    key: "en-US-XiaomiMiMoAPI开放平台计费即将启动",
    modifiedTime: ["1779936915101", "1779936970101"],
  },
  {
    path: "zh-CN/news/previous-news/recharge",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8940),
      ]).then(() => loadArchivedModule(69559)),
    key: "zh-CN-XiaomiMiMoAPI开放平台充值窗口正式开放公告",
    modifiedTime: ["1779937004101", "1779937013101"],
  },
  {
    path: "en-US/news/previous-news/recharge",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6092),
      ]).then(() => loadArchivedModule(29207)),
    key: "en-US-XiaomiMiMoAPI开放平台充值窗口正式开放公告",
    modifiedTime: ["1779937004101", "1779937013101"],
  },
  {
    path: "zh-CN/news/previous-news/news20260112",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1733),
      ]).then(() => loadArchivedModule(11188)),
    key: "zh-CN-MiMoV2Flash更新日志20260112",
    modifiedTime: ["1779950356101", "1779950360101"],
  },
  {
    path: "en-US/news/previous-news/news20260112",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(556),
      ]).then(() => loadArchivedModule(93655)),
    key: "en-US-MiMoV2Flash更新日志20260112",
    modifiedTime: ["1779950356101", "1779950360101"],
  },
  {
    path: "zh-CN/news/previous-news/beta-free",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3065),
      ]).then(() => loadArchivedModule(34368)),
    key: "zh-CN-MiMo模型公测限免延长公告",
    modifiedTime: ["1779937103101", "1779937117101"],
  },
  {
    path: "en-US/news/previous-news/beta-free",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6963),
      ]).then(() => loadArchivedModule(53374)),
    key: "en-US-MiMo模型公测限免延长公告",
    modifiedTime: ["1779937103101", "1779937117101"],
  },
  {
    path: "zh-CN/news/previous-news/news20251216",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8518),
      ]).then(() => loadArchivedModule(7413)),
    key: "zh-CN-MiMoV2Flash发布20251216",
    modifiedTime: ["1782701185101", "1782701196101"],
  },
  {
    path: "en-US/news/previous-news/news20251216",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1343),
      ]).then(() => loadArchivedModule(82962)),
    key: "en-US-MiMoV2Flash发布20251216",
    modifiedTime: ["1782701185101", "1782701196101"],
  },
  {
    path: "zh-CN/updates/model",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6533),
      ]).then(() => loadArchivedModule(65828)),
    key: "zh-CN-模型发布",
    modifiedTime: ["1790010223", "1790010227"],
  },
  {
    path: "en-US/updates/model",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(2434),
      ]).then(() => loadArchivedModule(67801)),
    key: "en-US-模型发布",
    modifiedTime: ["1790010223", "1790010227"],
  },
  {
    path: "zh-CN/updates/deprecate",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(6676),
      ]).then(() => loadArchivedModule(55455)),
    key: "zh-CN-DocN17799717157389j4suqm",
    modifiedTime: ["1790022137", "1790022141"],
  },
  {
    path: "en-US/updates/deprecate",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3745),
      ]).then(() => loadArchivedModule(440)),
    key: "en-US-DocN17799717157389j4suqm",
    modifiedTime: ["1790022137", "1790022141"],
  },
  {
    path: "zh-CN/updates/feature/platform",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8380),
      ]).then(() => loadArchivedModule(59943)),
    key: "zh-CN-功能更新",
    modifiedTime: ["1789971685", "1789971713"],
  },
  {
    path: "en-US/updates/feature/platform",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7940),
      ]).then(() => loadArchivedModule(4906)),
    key: "en-US-功能更新",
    modifiedTime: ["1789971685", "1789971713"],
  },
  {
    path: "zh-CN/updates/feature/desktop",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8996),
      ]).then(() => loadArchivedModule(29263)),
    key: "zh-CN-DocN17881484966460hgqupy",
    modifiedTime: ["1790656410", "1790656451"],
  },
  {
    path: "en-US/updates/feature/desktop",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(3911),
      ]).then(() => loadArchivedModule(53050)),
    key: "en-US-DocN17881484966460hgqupy",
    modifiedTime: ["1790656410", "1790656451"],
  },
  {
    path: "zh-CN/updates/feature/claw",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5989),
      ]).then(() => loadArchivedModule(64900)),
    key: "zh-CN-DocN17881487985902zbpin7",
    modifiedTime: ["1789897338", "1789897411"],
  },
  {
    path: "en-US/updates/feature/claw",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(8404),
      ]).then(() => loadArchivedModule(47551)),
    key: "en-US-DocN17881487985902zbpin7",
    modifiedTime: ["1789897338", "1789897411"],
  },
  {
    path: "zh-CN/updates/feature/studio",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(7782),
      ]).then(() => loadArchivedModule(78722)),
    key: "zh-CN-DocN178814882109294n6pk5",
    modifiedTime: ["1789994218", "1789994232"],
  },
  {
    path: "en-US/updates/feature/studio",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(5033),
      ]).then(() => loadArchivedModule(53504)),
    key: "en-US-DocN178814882109294n6pk5",
    modifiedTime: ["1789994218", "1789994232"],
  },
  {
    path: "zh-CN/updates/feature/mimo-code",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(4062),
      ]).then(() => loadArchivedModule(25517)),
    key: "zh-CN-DocN1788148821806hcqrg5z",
    modifiedTime: ["1788774662", "1788774737"],
  },
  {
    path: "en-US/updates/feature/mimo-code",
    importFn: () =>
      Promise.all([
        loadArchivedChunk(2374),
        loadArchivedChunk(2422),
        loadArchivedChunk(9832),
        loadArchivedChunk(616),
        loadArchivedChunk(1936),
      ]).then(() => loadArchivedModule(62627)),
    key: "en-US-DocN1788148821806hcqrg5z",
    modifiedTime: ["1788774662", "1788774737"],
  },
];
const recoveredExportvg = [
  {
    fromPrefix:
      "quick-start/usage-guide/multimodal-understanding/speech-synthesis-v2.5",
    toPrefix: "quick-start/usage-guide/audio/speech-synthesis-v2.5",
  },
  {
    fromPrefix:
      "quick-start/usage-guide/multimodal-understanding/Speech-Recognition",
    toPrefix: "quick-start/usage-guide/audio/Speech-Recognition",
  },
  {
    fromPrefix:
      "quick-start/usage-guide/multimodal-understanding/speech-synthesis",
    toPrefix: "quick-start/usage-guide/audio/speech-synthesis-v2.5",
  },
  {
    fromPrefix: "usage-guide/multimodal-understanding/image-understanding",
    toPrefix:
      "quick-start/usage-guide/multimodal-understanding/image-understanding",
  },
  {
    fromPrefix: "usage-guide/multimodal-understanding/audio-understanding",
    toPrefix:
      "quick-start/usage-guide/multimodal-understanding/audio-understanding",
  },
  {
    fromPrefix: "usage-guide/multimodal-understanding/video-understanding",
    toPrefix:
      "quick-start/usage-guide/multimodal-understanding/video-understanding",
  },
  {
    fromPrefix: "quick-start/usage-guide/tool-calling/web-search",
    toPrefix: "quick-start/usage-guide/text-generation/tool-calling/web-search",
  },
  {
    fromPrefix: "quick-start/usage-guide/audio/speech-synthesis",
    toPrefix: "quick-start/usage-guide/audio/speech-synthesis-v2.5",
  },
  {
    fromPrefix: "quick-start/usage-guide/other/deep-thinking",
    toPrefix: "quick-start/usage-guide/text-generation/deep-thinking",
  },
  {
    fromPrefix: "usage-guide/passing-back-reasoning_content",
    toPrefix: "quick-start/usage-guide/text-generation/deep-thinking",
  },
  {
    fromPrefix: "news/previous-news/free-trial-extension",
    toPrefix: "news/latest/free-trial-extension",
  },
  {
    fromPrefix: "quick-start/usage-guide/deep-thinking",
    toPrefix: "quick-start/usage-guide/text-generation/deep-thinking",
  },
  {
    fromPrefix: "news/previous-news/token-plan-release",
    toPrefix: "news/latest/token-plan-release",
  },
  {
    fromPrefix: "model-intro/mimo-v2.5-pro-ultraspeed",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "quick-start/usage-guide/tool-calling",
    toPrefix: "quick-start/usage-guide/text-generation/tool-calling/web-search",
  },
  {
    fromPrefix: "usage-guide/multimodal-understanding",
    toPrefix:
      "quick-start/usage-guide/multimodal-understanding/image-understanding",
  },
  {
    fromPrefix: "integration/openclaw-with-openrouter",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "usage-guide/tool-calling/web-search",
    toPrefix: "quick-start/usage-guide/text-generation/tool-calling/web-search",
  },
  {
    fromPrefix: "news/previous-news/v2.5-tts-release",
    toPrefix: "news/latest/v2.5-tts-release",
  },
  {
    fromPrefix: "usage-guide/speech-synthesis-v2.5",
    toPrefix: "quick-start/usage-guide/audio/speech-synthesis-v2.5",
  },
  {
    fromPrefix: "quick-start/model-hyperparameters",
    toPrefix: "api/guidance/model-hyperparameters",
  },
  {
    fromPrefix: "api/text-generation/anthropic-api",
    toPrefix: "api/chat/anthropic-api",
  },
  {
    fromPrefix: "price/tokenplan/price-comparison",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "usage-guide/Speech-Recognition",
    toPrefix: "quick-start/usage-guide/audio/Speech-Recognition",
  },
  {
    fromPrefix: "api/text-generation/openai-api",
    toPrefix: "api/chat/openai-api",
  },
  {
    fromPrefix: "news/previous-news/hermes-free",
    toPrefix: "news/latest/hermes-free",
  },
  {
    fromPrefix: "quick-start/usage-guide/other",
    toPrefix: "quick-start/usage-guide/text-generation/deep-thinking",
  },
  {
    fromPrefix: "previous-news/first-week-free",
    toPrefix: "news/previous-news/first-week-free",
  },
  {
    fromPrefix: "previous-news/v2-omni-release",
    toPrefix: "news/previous-news/v2-omni-release",
  },
  {
    fromPrefix: "usage-guide/speech-synthesis",
    toPrefix: "quick-start/usage-guide/audio/speech-synthesis-v2.5",
  },
  {
    fromPrefix: "price/tokenplan/subscription",
    toPrefix: "tokenplan/Token Plan/subscription",
  },
  {
    fromPrefix: "price/tokenplan/quick-access",
    toPrefix: "tokenplan/Token Plan/quick-access",
  },
  {
    fromPrefix: "news/previous-news/v2.5-news",
    toPrefix: "news/latest/v2.5-news",
  },
  {
    fromPrefix: "previous-news/v2-pro-release",
    toPrefix: "news/previous-news/v2-pro-release",
  },
  {
    fromPrefix: "previous-news/v2-tts-release",
    toPrefix: "news/previous-news/v2-tts-release",
  },
  {
    fromPrefix: "news/latest/first-week-free",
    toPrefix: "news/previous-news/first-week-free",
  },
  {
    fromPrefix: "news/latest/v2-omni-release",
    toPrefix: "news/previous-news/v2-omni-release",
  },
  {
    fromPrefix: "api/audio/Speech-Synthesis",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "quick-start/first-api-call",
    toPrefix: "quick-start/summary/first-api-call",
  },
  {
    fromPrefix: "integration/cline-kilo-roo",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "integration/tools-overview",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "news/latest/v2-pro-release",
    toPrefix: "news/previous-news/v2-pro-release",
  },
  {
    fromPrefix: "news/latest/v2-tts-release",
    toPrefix: "news/previous-news/v2-tts-release",
  },
  {
    fromPrefix: "api/model-hyperparameters",
    toPrefix: "api/guidance/model-hyperparameters",
  },
  {
    fromPrefix: "news/free-trial-extension",
    toPrefix: "news/latest/free-trial-extension",
  },
  {
    fromPrefix: "usage-guide/tool-calling",
    toPrefix: "quick-start/usage-guide/text-generation/tool-calling/web-search",
  },
  {
    fromPrefix: "integration/hermes-agent",
    toPrefix: "tokenplan/integration/hermes-agent",
  },
  {
    fromPrefix: "integration/cherrystudio",
    toPrefix: "tokenplan/integration/cherrystudio",
  },
  {
    fromPrefix: "quick-start/error-codes",
    toPrefix: "api/guidance/error-codes",
  },
  {
    fromPrefix: "integration/claude-code",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "news/token-plan-release",
    toPrefix: "news/latest/token-plan-release",
  },
  {
    fromPrefix: "tokenplan/subscription",
    toPrefix: "tokenplan/Token Plan/subscription",
  },
  {
    fromPrefix: "tokenplan/quick-access",
    toPrefix: "tokenplan/Token Plan/quick-access",
  },
  {
    fromPrefix: "integration/claudecode",
    toPrefix: "tokenplan/integration/claudecode",
  },
  {
    fromPrefix: "news/v2.5-price-update",
    toPrefix: "news/latest/v2.5-price-update",
  },
  {
    fromPrefix: "news/v2.5-open-sourced",
    toPrefix: "news/latest/v2.5-open-sourced",
  },
  {
    fromPrefix: "news/v2.5-TTS-release",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "news/v2.5-tts-release",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "integration/open-claw",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "integration/codebuddy",
    toPrefix: "tokenplan/integration/codebuddy",
  },
  {
    fromPrefix: "terms/user-agreement",
    toPrefix: "quick-start/terms/user-agreement",
  },
  {
    fromPrefix: "terms/privacy-policy",
    toPrefix: "quick-start/terms/privacy-policy",
  },
  {
    fromPrefix: "integration/opencode",
    toPrefix: "tokenplan/integration/opencode",
  },
  {
    fromPrefix: "integration/openclaw",
    toPrefix: "tokenplan/integration/openclaw",
  },
  {
    fromPrefix: "integration/kilocode",
    toPrefix: "tokenplan/integration/kilocode",
  },
  {
    fromPrefix: "integration/qwencode",
    toPrefix: "tokenplan/integration/qwencode",
  },
  {
    fromPrefix: "news/first-week-free",
    toPrefix: "news/previous-news/first-week-free",
  },
  {
    fromPrefix: "news/v2-omni-release",
    toPrefix: "news/previous-news/v2-omni-release",
  },
  {
    fromPrefix: "integration/roocode",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "news/v2-pro-release",
    toPrefix: "news/previous-news/v2-pro-release",
  },
  {
    fromPrefix: "news/v2-tts-release",
    toPrefix: "news/previous-news/v2-tts-release",
  },
  {
    fromPrefix: "XiaomiMiMoPlatform",
    toPrefix: "quick-start/terms/privacy-policy",
  },
  {
    fromPrefix: "news/v2.5-release",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "quick-start/model",
    toPrefix: "quick-start/summary/model",
  },
  {
    fromPrefix: "integration/tools",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "integration/codex",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "integration/cline",
    toPrefix: "tokenplan/integration/cline",
  },
  {
    fromPrefix: "news/news20260303",
    toPrefix: "news/previous-news/news20260303",
  },
  {
    fromPrefix: "news/news20260212",
    toPrefix: "news/previous-news/news20260212",
  },
  {
    fromPrefix: "news/news20260112",
    toPrefix: "news/previous-news/news20260112",
  },
  {
    fromPrefix: "news/news20251216",
    toPrefix: "news/previous-news/news20251216",
  },
  {
    fromPrefix: "promotions/refer",
    toPrefix: "quick-start/promotions/refer",
  },
  {
    fromPrefix: "integration/trae",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "news/hermes-free",
    toPrefix: "news/latest/hermes-free",
  },
  {
    fromPrefix: "api/error-codes",
    toPrefix: "api/guidance/error-codes",
  },
  {
    fromPrefix: "price/tokenplan",
    toPrefix: "tokenplan/Token Plan/subscription",
  },
  {
    fromPrefix: "integration/zed",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "news/v2.5-orbit",
    toPrefix: "news/latest/v2.5-orbit",
  },
  {
    fromPrefix: "news/v2.5-news",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "api/rate-limit",
    toPrefix: "api/guidance/rate-limit",
  },
  {
    fromPrefix: "news/beta-free",
    toPrefix: "news/previous-news/beta-free",
  },
  {
    fromPrefix: "news/recharge",
    toPrefix: "news/previous-news/recharge",
  },
  {
    fromPrefix: "news/billing",
    toPrefix: "news/previous-news/billing",
  },
  {
    fromPrefix: "model-intro",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "usage-guide",
    toPrefix: "quick-start/usage-guide/text-generation/tool-calling/web-search",
  },
  {
    fromPrefix: "integration",
    toPrefix: "tokenplan/integration/tools-overview",
  },
  {
    fromPrefix: "promotions",
    toPrefix: "quick-start/promotions/refer",
  },
  {
    fromPrefix: "batch-api",
    toPrefix: "quick-start/usage-guide/text-generation/batch-api",
  },
  {
    fromPrefix: "welcome",
    toPrefix: "quick-start/summary/welcome",
  },
  {
    fromPrefix: "pricing",
    toPrefix: "price/pay-as-you-go",
  },
  {
    fromPrefix: "feature",
    toPrefix: "updates/feature/platform",
  },
  {
    fromPrefix: "terms",
    toPrefix: "quick-start/terms/user-agreement",
  },
  {
    fromPrefix: "faq",
    toPrefix: "quick-start/faq/account",
  },
];
export { archivedDocuments, recoveredExportvg as vg };
